import Vue from 'vue'
import VueRouter from 'vue-router'
import { RawLocation } from 'vue-router/types/router'

import { ReturnUrlHelper } from './ReturnUrlHelper'
import replaceRoute from './replace-route'

export default function (vue: Vue, options: { router: VueRouter }): void {
  if (!options || !options.router) {
    throw new Error('Please initialise plugin with a Vuex store.')
  }

  // eslint-disable-next-line no-underscore-dangle,@typescript-eslint/naming-convention
  const _vue = vue as any

  if (_vue.$replaceRoute === undefined) {
    _vue.prototype.$replaceRoute = function (route: RawLocation): void {
      replaceRoute(options.router, route)
    }
  } else {
    throw new Error('$replaceRoute already exists on Vue instance')
  }

  if (_vue.$returnUrlHelper === undefined) {
    _vue.prototype.$returnUrlHelper = ReturnUrlHelper
  } else {
    throw new Error('$returnUrlHelper already exists on Vue instance')
  }
}
